import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class BackendInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  private isAuthEndpoint(url: string): boolean {
    const path = url.toLowerCase();
    return (
      path.includes('/login/') ||
      path.includes('/login/complete/') ||
      path.includes('/password-reset') ||
      path.includes('/verify-otp') ||
      path.includes('/authentication/')
    );
  }

  private isOnAuthPage(): boolean {
    const url = this.router.url || '';
    return url.startsWith('/authentication');
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token: any = sessionStorage.getItem('token');
    if (token != undefined) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Wrong credentials / auth flow errors must not show "Session expired"
          const skipSessionModal =
            this.isAuthEndpoint(request.url) || this.isOnAuthPage() || !token;

          if (skipSessionModal) {
            // Clear stale token if present, but let the login page handle the error UI
            if (this.isAuthEndpoint(request.url) || this.isOnAuthPage()) {
              sessionStorage.removeItem('token');
            }
            return throwError(() => error);
          }

          sessionStorage.removeItem('token');
          Swal.fire({
            icon: 'warning',
            title: 'Session expired',
            text: 'Your session has expired. Please sign in again.',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then(() => {
            this.router.navigate(['/authentication/login']);
          });
        }
        return throwError(() => error);
      })
    );
  }
}
